import styled from "@emotion/styled";
import { FC } from "react";

import { Alert } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { StyledLink } from "components/links/StyledLink";
import { AgentsRoutes } from "routes/agents/constants";

export const ChannelManagementAlert: FC = () => (
  <Block maxWidth="800px" data-testid="channel-management-alert">
    <StyledAlert kind="info">
      You can&apos;t manage this channel in your current HelpDesk role.{" "}
      <StyledLink kind="link-light" to={AgentsRoutes.Agents}>
        Contact any admin
      </StyledLink>{" "}
      to change your role to admin.
    </StyledAlert>
  </Block>
);

const StyledAlert = styled(Alert)`
  text-align: start;
`;
